import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "youtube-icon",
  "use": "youtube-icon-usage",
  "viewBox": "0 0 59 59",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 59 59\" id=\"youtube-icon\"><g fill=\"none\" fill-rule=\"evenodd\"><ellipse fill=\"#003595\" cx=\"29.33\" cy=\"29.198\" rx=\"29.33\" ry=\"29.198\" /><path d=\"M43.02 23.869c0-2.323-1.81-4.202-4.04-4.202H20.02c-2.232 0-4.04 1.882-4.04 4.202v11.265c0 2.317 1.808 4.2 4.04 4.2h18.955c2.233 0 4.044-1.883 4.044-4.2V23.869h.002zM27.043 34.417V23.354l7.375 5.531-7.375 5.532z\" fill=\"#FFF\" fill-rule=\"nonzero\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol